<template>
    <div>
        <div style="margin:100px auto 0 auto; width: 80%;">
            <vue-plyr ref="plyr">
            <audio>
                <!-- <source src="https://cdn.plyr.io/static/demo/Kishi_Bashi_-_It_All_Began_With_a_Burst.mp3" type="audio/mp3"/> -->
            </audio>
            </vue-plyr>
        </div>
        <div class="text-center">
            <b-button @click.prevent="play(0)">Harp 0</b-button>
            <b-button @click.prevent="play(1)">Harp 1</b-button>
            <b-button @click.prevent="play(2)">Harp 2</b-button>
            <b-button @click.prevent="play(3)">Harp 3</b-button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
'use strict'
import service from "@/service/service"
import utils from "@/utils/utils"
// import VuePlyr from 'vue-plyr'

let data = {
    player: null,
    playerInit: false,
    arr: [
        'https://cdn.plyr.io/static/demo/Kishi_Bashi_-_It_All_Began_With_a_Burst.mp3',
        'https://cdn.viva9.us/contrib/va/podcast/harp1.mp3',
        'https://cdn.viva9.us/contrib/va/podcast/harp2.mp3',
        'https://cdn.viva9.us/contrib/va/podcast/harp3.mp3',        
    ]
}

export default {
  name: 'Plyr',
  data () {
    return data
  },
  methods: {
    play(ix) {
        if (!this.player) {
            this.playerEvents()
        }
        console.log(`changing to: ${this.arr[ix]}`)
        // source setter
        // https://github.com/sampotts/plyr#the-source-setter
        this.player.source = {
            type: 'audio',
            title: `Harp ${ix}`,
            sources: [
                {
                    src: this.arr[ix],
                    type: 'audio/mp3',
                }
            ]
        }
        console.log(this.player.source)
    },
    playerEvents () {
        if (this.$refs['plyr']) {
            console.log(`playerEvents called`)

            this.playerInit = true
            this.player = this.$refs['plyr'].player

            // 'statechange','ready','canplay','error','progress','playing','play','pause','ended'
            this.player.on('statechange', () => console.log('event statechange'))
            this.player.on('ready', () => console.log('event ready'))
            this.player.on('canplay', (e) => {
                console.log('event canplay')
                console.log(e)
                this.player.play()
            })
            this.player.on('canplaythrough', () => console.log('event canplaythrough'))
            this.player.on('error', () => console.log('event error'))
            this.player.on('progress', () => console.log('event progress'))
            this.player.on('playing', () => console.log('event playing'))
            this.player.on('play', () => console.log('event play'))
            this.player.on('pause', () => console.log('event pause'))
            this.player.on('ended', () => console.log('event ended'))
        }
        else {
            console.log(`plyr not found!`)
            alert(`plyr not found`)
        }
    }
  },  
  created() { 
  },
  mounted() { 
      console.log(`mounted`) 
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Plyr.vue